import { BrowserRouter, Switch, Route } from 'react-router-dom';

import PrivateRoute from './components/PrivateRoute';

import Landing from './pages/Landing';
import About from './pages/About';
import Register from './pages/Register';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import VerifyAccount from './pages/VerifyAccount';
import EnterVerificationCode from './pages/VerifyAccount/EnterCode';

const Routes = () => (
    <BrowserRouter>
        <Switch>
            <Route path="/" component={Landing} exact/>
            <Route path="/register" component={Register} exact/>
            <Route path="/login" component={Login} exact/>
            <Route path="/verify-account" component={VerifyAccount} exact/>
            <Route path="/verify-account/enter-code" component={EnterVerificationCode} exact/>
            <PrivateRoute path="/dashboard" component={Dashboard} />
            <Route path="/about" component={About} exact/>
        </Switch>
    </BrowserRouter>
);

export default Routes;